import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import { ProductStoreProvider } from './context/ProductStore';
import Header from './components/Header';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import ChatAgent from './components/ChatAgent';
import Home from './pages/Home';
import Shop from './pages/Shop';
import Services from './pages/Services';
import About from './pages/About';
import Contact from './pages/Contact';
import './styles/index.css';

function App() {
  return (
    <ThemeProvider>
      <ProductStoreProvider>
        <Router>
          <div style={styles.app}>
            <Header />
            <Routes>
              <Route path="/"         element={<Home />}     />
              <Route path="/shop"     element={<Shop />}     />
              <Route path="/services" element={<Services />} />
              <Route path="/about"    element={<About />}    />
              <Route path="/contact"  element={<Contact />}  />
            </Routes>
            <Footer />
            {/* WhatsApp button — bottom right */}
            <WhatsAppButton />
            {/* AI Chat Agent — bottom left */}
            <ChatAgent />
          </div>
        </Router>
      </ProductStoreProvider>
    </ThemeProvider>
  );
}

const styles = {
  app: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
  },
};

export default App;
